import React from "react";
import styled from "styled-components";

const LinkThumbnail = styled.img`
	margin-right: 5px;
	object-fit: contain;
	max-height: 75px;
`

export default function ItemLinks(props) {
	const { links } = props

	return (<>
		{links.map((link, idx) => {
			return (
				<div key={idx} style={{ margin: "4px" }}>
					{link.thumbnail && <LinkThumbnail src={link.thumbnail} width="75px" />}
					<a href={link.linkPath} target="_blank" rel="noreferrer">{link.title}</a>
				</div>
			)
		})}
	</>)
}